const values = {
    HOST: 'https://api.alocubatravel.com',
    IMAGE_CDN_URL: 'https://ik.imagekit.io/oiimkmcyr/{imageName}?tr=w-{width},h-{height}',
    CLIENT_ORDER_TRACKER_UI_URL: 'https://client.alocubatravel.com/order-tracking/{id}',
    AUTH_URL: "{HOST}/authenticate",
    GET_SELLERS_URL: "{HOST}/seller?page={page}&pageSize={pageSize}&filter={filter}&includeCurrent={includeCurrent}&agencyId={agencyId}&status={status}",
    FIND_SELLER_URL: "{HOST}/seller/{id}",
    CREATE_SELLER_URL: "{HOST}/seller",
    UPDATE_SELLER_URL: "{HOST}/seller/{id}",
    SET_SELLER_ACTIVE_URL: "{HOST}/seller/{id}/setActive",
    SET_SELLER_INACTIVE_URL: "{HOST}/seller/{id}/setInactive",
    REMOVE_SELLER_URL: "{HOST}/seller/{id}",
    GET_PRODUCTS_URL: "{HOST}/product-order/topup/product",
    GET_ALL_PRODUCTS_URL: "{HOST}/product-order/topup/product/all",
    UPDATE_PRODUCT_ENABLED_URL: "{HOST}/product-order/topup/product/{id}/enabled",
    GET_TOPUP_PRICES_URL: "{HOST}/product-order/topup/price",
    CREATE_TOPUP_PRICE_URL: "{HOST}/product-order/topup/price",
    UPDATE_TOPUP_PRICE_URL: "{HOST}/product-order/topup/price/{id}",
    REMOVE_TOPUP_PRICE_URL: "{HOST}/product-order/topup/price/{id}",
    GET_TOPUP_AVAILABLE_BALANCE: "{HOST}/product-order/topup/balance",
    VALIDATE_TOPUP_URL: "{HOST}/product-order/topup/validate",
    DO_TOPUP_URL: "{HOST}/product-order/topup",
    CONFIRM_TOPUP_URL: "{HOST}/product-order/topup/{id}/confirm",
    GET_TOPUPS_URL: "{HOST}/product-order/topup?page={page}&pageSize={pageSize}&clientId={clientId}&contactId={contactId}&geoId={geoId}&from={from}&to={to}&status={status}&agencyId={agencyId}&filter={filter}",
    
    // AGENCY
    GET_AGENCY_TOTAL_BALANCE_URL: "{HOST}/agency/total-balance",
    GET_AGENCY_BALANCE_URL: "{HOST}/agency/balance",
    GET_AGENCIES_BALANCE_REPORT_URL: "{HOST}/agency/balance-report",

    // CLIENTS
    GET_CLIENTS_URL: "{HOST}/client?page={page}&pageSize={pageSize}&filter={filter}&agencyId={agencyId}&from={from}&to={to}",
    FIND_CLIENT_URL: "{HOST}/client/{id}",
    CREATE_CLIENT_URL: "{HOST}/client",
    UPDATE_CLIENT_URL: "{HOST}/client/{id}",
    REMOVE_CLIENT_URL: "{HOST}/client/{id}",
    GET_CLIENTS_CSV_URL: "{HOST}/client/google-contacts/csv?ids={ids}",

    // CONTACTS
    GET_CLIENT_CONTACT_URL: "{HOST}/client/{id}/contact?page={page}&pageSize={pageSize}&filter={filter}&agencyId={agencyId}",
    FIND_CLIENT_CONTACT_URL: "{HOST}/client/{id}/contact/{contactId}",
    CREATE_CLIENT_CONTACT_URL: "{HOST}/client/{id}/contact",
    UPDATE_CLIENT_CONTACT_URL: "{HOST}/client/{id}/contact/{contactId}",
    REMOVE_CLIENT_CONTACT_URL: "{HOST}/client/{id}/contact/{contactId}",
    SEARCH_CLIENT_CONTACT_URL: "{HOST}/client-contact/search?filter={filter}&clientId={clientId}",
    PASSWORD_VALIDATE_CODE_URL: "{HOST}/validate-password-code",
    PASSWORD_VALIDATE_DELIVERY_PERSON_CODE_URL: "{HOST}/validate-password-code/delivery-person",
    CHANGE_PASSWORD_URL: "{HOST}/change-password",
    CHANGE_PASSWORD_DELIVERY_PERSON_URL: "{HOST}/change-password/delivery-person",
    GET_ROLE_URL: "{HOST}/role",
    GET_ALL_ACCESS_URL: "{HOST}/access",
    GET_NEW_ACCESS_VALUE_URL: "{HOST}/access/next-value",
    GET_ROLE_ACCESS_URL: "{HOST}/role/{id}/access",
    TOGGLE_ROLE_ACCESS_URL: "{HOST}/role/{id}/toggle-access/{access}",
    RECOVER_PASSWORD_URL: "{HOST}/recover-password",
    GET_AGENCY_URL: "{HOST}/agency?page={page}&pageSize={pageSize}&filter={filter}&includeChildren={includeChildren}&includeCurrent={includeCurrent}&onlyWithBalance={onlyWithBalance}",
    CREATE_AGENCY_URL: "{HOST}/agency",
    UPDATE_AGENCY_URL: "{HOST}/agency/{id}",
    FIND_AGENCY_URL: "{HOST}/agency/{id}",
    REMOVE_AGENCY_URL: "{HOST}/agency/{id}",
    SET_AGENCY_SALE_PRICE_URL: "{HOST}/agency/{agencyId}/sale-price/{salePriceId}",
    GET_AGENCY_DOCUMENT_SETTINGS_URL: "{HOST}/agency-document-settings?agencyId={agencyId}",
    UPDATE_AGENCY_DOCUMENT_SETTINGS_URL: "{HOST}/agency-document-settings?agencyId={agencyId}",
    UPLOAD_AGENCY_DOCUMENT_LOGO_URL: "{HOST}/agency-document-settings/upload-logo?agencyId={agencyId}",
    DOWNLOAD_AGENCY_ORDER_REPORT_URL: "{HOST}/agency/{id}/order-report?from={from}&to={to}",
    DOWNLOAD_AGENCY_ORDER_REPORT_SUMMARIZED_URL: "{HOST}/agency/{id}/summarized-order-report?from={from}&to={to}&cancellation={cancellation}&other={other}&observation={observation}",
    DOWNLOAD_SELLER_SALES_REPORT_URL: "{HOST}/seller/{id}/sales-report?from={from}&to={to}",
    DOWNLOAD_AGENCY_SALES_REPORT_URL: "{HOST}/agency/{id}/sales-report?from={from}&to={to}",
    DOWNLOAD_APP_URL: "{HOST}/apk/{fileName}/download",
    UPDATE_AGENCY_MAIN_USER_PASSWORD_URL: "{HOST}/agency/{id}/update-main-user-password",
    UPDATE_DELIVERY_PERSON_PASSWORD_URL: "{HOST}/delivery-person/{id}/update-password",
    UPDATE_SELLER_PASSWORD_URL: "{HOST}/seller/{id}/update-password",
    GET_CLIENT_VCF_URL: "{HOST}/client/{id}/download-vcf",

    // ARTICLE
    GET_ARTICLE_URL: "{HOST}/article?page={page}&pageSize={pageSize}&filter={filter}&categoryId={categoryId}",
    GET_ALL_ARTICLE_URL: "{HOST}/all-article",
    FILTER_ARTICLE_URL: "{HOST}/article/geo/{id}?filter={filter}&categoryId={categoryId}&agencyId={agencyId}",
    FIND_ARTICLE_URL: "{HOST}/article/{id}",
    CREATE_ARTICLE_URL: "{HOST}/article",
    UPDATE_ARTICLE_URL: "{HOST}/article/{id}",
    REMOVE_ARTICLE_URL: "{HOST}/article/{id}",
    UPLOAD_ARTICLE_IMAGE_URL: "{HOST}/article/{id}/upload-image",

    GET_ARTICLE_PRICE_URL: "{HOST}/article/{id}/price?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_ARTICLE_PRICE_URL: "{HOST}/article/{id}/price/{priceId}",
    CREATE_ARTICLE_PRICE_URL: "{HOST}/article/{id}/price",
    UPDATE_ARTICLE_PRICE_URL: "{HOST}/article/price/{id}",
    BULK_UPDATE_ARTICLE_PRICE_URL: "{HOST}/article/prices",
    SEARCH_ARTICLE_PRICE_URL: "{HOST}/article/price/search?filter={filter}",
    REMOVE_ARTICLE_PRICE_URL: "{HOST}/article/price/{id}",
    GET_BULK_ARTICLE_PRICE_URL: "{HOST}/article/price",
    GET_AGENCIES_ARTICLE_PRICES_URL: "{HOST}/sale-price/{salePriceId}/article/{id}/all-agencies-prices?deliveryTimeDays={deliveryTimeDays}",

    SEARCH_GEO_URL: "{HOST}/geo?page={page}&pageSize={pageSize}&filter={filter}&level={level}&parentIdFilter={parentIdFilter}",
    UPDATE_GEO_URL: "{HOST}/geo/{id}",

    GET_ARTICLE_PROD_COST_URL: "{HOST}/article/{id}/production-cost?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_ARTICLE_PROD_COST_URL: "{HOST}/article/{id}/production-cost/{productionCostId}",
    CREATE_ARTICLE_PROD_COST_URL: "{HOST}/article/{id}/production-cost",
    UPDATE_ARTICLE_PROD_COST_URL: "{HOST}/article/{id}/production-cost/{productionCostId}",
    SEARCH_ARTICLE_PROD_COST_URL: "{HOST}/article/production-cost/search?filter={filter}",
    REMOVE_ARTICLE_PROD_COST_URL: "{HOST}/article/production-cost/{id}",

    // ARTICLE WAREHOUSE
    GET_ARTICLE_WAREHOUSES_URL: "{HOST}/article-warehouse?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_ARTICLE_WAREHOUSE_URL: "{HOST}/article-warehouse/{id}",
    CREATE_ARTICLE_WAREHOUSE_URL: "{HOST}/article-warehouse",
    UPDATE_ARTICLE_WAREHOUSE_URL: "{HOST}/article-warehouse/{id}",
    TRANSFER_ARTICLE_FROM_WAREHOUSE_TO_DELIVERY_PERSON_URL: "{HOST}/article-warehouse/{id}/article/transfer",

    // PRODUCT ORDER
    GET_PRODUCT_ORDER_URL: "{HOST}/product-order?from={from}&to={to}&clientId={clientId}",
    ADD_DELIVERY_COMMENT_URL: "{HOST}/product-order/{id}/comment",
    GET_PRODUCT_ORDER_COMMENTS_URL: "{HOST}/product-order/{id}/comments",
    GET_PRODUCT_ORDER_ATTACHMENTS_URL: "{HOST}/product-order/{id}/attachments",
    UPDATE_DELIVERY_OBSERVATIONS_URL: "{HOST}/product-order/{id}/observations",
    REMOVE_PRODUCT_ORDERS_URL: "{HOST}/product-orders?ids={ids}",
    RECALCULATE_PRODUCT_ORDERS_SERVICE_COST_URL: "{HOST}/product-order/service-cost/recalculate",
    GET_PRODUCT_ORDER_PROFIT_OVERVIEW: "{HOST}/product-order/profit-overview?from={from}&to={to}",

    // ARTICLE DELIVERY ORDER
    GET_ARTICLE_REMITTANCE_URL: "{HOST}/product-order/article-delivery?page={page}&pageSize={pageSize}&from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&articleId={articleId}&status={status}&geoId={geoId}&agencyId={agencyId}",
    FIND_ARTICLE_REMITTANCE_URL: "{HOST}/product-order/article-delivery/{id}",
    CREATE_ARTICLE_REMITTANCE_URL: "{HOST}/product-order/article-delivery",
    UPDATE_ARTICLE_REMITTANCE_URL: "{HOST}/product-order/article-delivery/{id}",
    SET_ARTICLE_DELIVERY_FLOW_URL: "{HOST}/product-order/article-delivery/delivery-flow",
    DISPATCH_WAREHOUSE_STEP_URL: "{HOST}/product-order/article-delivery/{orderId}/warehouse/{warehouseId}/dispatched",

    // RECEIVED AND DELIVERED CONFIRMATION
    CONFIRM_ARTICLE_DELIVERY_RECEIVED_URL: "{HOST}/product-order/article-delivery/{id}/delivery-person/{deliveryPersonId}/received",
    CONFIRM_ARTICLE_DELIVERY_DELIVERED_URL: "{HOST}/product-order/article-delivery/{id}/delivery-person/{deliveryPersonId}/delivered",

    GET_ARTICLE_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/article-delivery/profit-overview?from={from}&to={to}",
    GET_MISCELLANY_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/miscellany/profit-overview?from={from}&to={to}",
    GET_MONEY_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/money-delivery/profit-overview?from={from}&to={to}",
    GET_PACKAGE_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/package-delivery/profit-overview?from={from}&to={to}",
    GET_SHOP_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/shop/profit-overview?from={from}&to={to}",
    GET_TOPUP_ORDERS_PROFIT_OVERVIEW: "{HOST}/product-order/topup/profit-overview?from={from}&to={to}",

    SET_ARTICLE_REMITTANCE_DELIVERY_PERSON_URL: "{HOST}/product-order/article-delivery/delivery-person/{deliveryPersonId}",
    UNSET_ARTICLE_REMITTANCE_DELIVERY_PERSON_URL: "{HOST}/product-order/article-delivery/{articleRemitanteId}",
    
    REMOVE_ARTICLE_DELIVERY_ORDER_URL: "{HOST}/product-order/article-delivery/{id}",
    UPDATE_ARTICLE_DELIVERY_ORDER_STATUS_URL: "{HOST}/product-order/article-delivery/{articleDeliveryId}/status/{status}",
    UPDATE_ARTICLE_DELIVERY_ORDERS_STATUS_URL: "{HOST}/product-order/article-delivery/status/{status}",

    // ARTICLE STOCK
    GET_ARTICLE_STOCK_URL: "{HOST}/article-stock?page={page}&pageSize={pageSize}&articleId={articleId}&entityId={entityId}",
    GET_ASSIGNED_ARTICLE_STOCK_AMOUNT_URL: "{HOST}/article/{id}/assigned-article-stock",
    ADD_ARTICLE_STOCK_URL: "{HOST}/article-stock",
    MARK_DAMAGED_ARTICLE_STOCK_URL: "{HOST}/article-stock/damaged",
    COLLECT_DAMAGED_ARTICLE_STOCK_URL: "{HOST}/article-stock/damaged/collect",

    // ARTICLE CATEGORY
    GET_ARTICLE_CATEGORY_URL: "{HOST}/article-category?page={page}&pageSize={pageSize}",
    FIND_ARTICLE_CATEGORY_URL: "{HOST}/article-category/{id}",
    CREATE_ARTICLE_CATEGORY_URL: "{HOST}/article-category",
    UPDATE_ARTICLE_CATEGORY_URL: "{HOST}/article-category/{id}",
    REMOVE_ARTICLE_CATEGORY_URL: "{HOST}/article-category/{id}",

    // STATUS HISTORY
    GET_PRODUCT_ORDER_STATUS_HISTORY_URL: "{HOST}/product-order/{id}/status-history",

    GET_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/{id}/additional-price?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/{id}/additional-price/{additionalPriceId}",
    CREATE_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/{id}/additional-price",
    UPDATE_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/{id}/additional-price/{additionalPriceId}",
    SEARCH_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/additional-price/search?filter={filter}",
    REMOVE_REMITTANCE_ADDITIONAL_PRICE_URL: "{HOST}/remittance/additional-price/{id}",

    GET_DELIVERY_PERSON_URL: "{HOST}/delivery-person/get?page={page}&pageSize={pageSize}&filter={filter}&activeMoneyDeliveryBalances={activeMoneyDeliveryBalances}",
    GET_DELIVERY_PERSON_TOTAL_BALANCES_URL: "{HOST}/delivery-person/total-balances",
    FIND_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}",
    CREATE_DELIVERY_PERSON_URL: "{HOST}/delivery-person",
    UPDATE_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}",
    REMOVE_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}",
    ADD_BALANCE_TO_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}/balance",
    TRANSFER_BALANCE_TO_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}/balance/transfer",
    TRANSFER_ARTICLE_TO_DELIVERY_PERSON_URL: "{HOST}/delivery-person/{id}/article/transfer",
    GET_DELIVERY_PERSON_CSV_URL: "{HOST}/delivery-person/csv?filter={filter}",

    GET_MONEY_EXCHANGE_URL: "{HOST}/money-exchange-rate?page={page}&pageSize={pageSize}&agencyId={agencyId}&filter={filter}",
    FIND_MONEY_EXCHANGE_URL: "{HOST}/money-exchange-rate/{id}",
    CREATE_MONEY_EXCHANGE_URL: "{HOST}/money-exchange-rate",
    UPDATE_MONEY_EXCHANGE_URL: "{HOST}/money-exchange-rate/{id}",
    UPDATE_MONEY_EXCHANGES_URL: "{HOST}/money-exchange-rates",
    REMOVE_MONEY_EXCHANGE_URL: "{HOST}/money-exchange-rate/{id}",

    GET_MONEY_DELIVERY_FEE_URL: "{HOST}/money-delivery-fee?page={page}&pageSize={pageSize}&filter={filter}",
    GET_MONEY_DELIVERY_FEE_FROM_BASE_AGENCY_URL: "{HOST}/money-delivery-fee/from-base-agency",
    FIND_MONEY_DELIVERY_FEE_URL: "{HOST}/money-delivery-fee/{id}",
    CREATE_MONEY_DELIVERY_FEE_URL: "{HOST}/money-delivery-fee",
    UPDATE_MONEY_DELIVERY_FEE_URL: "{HOST}/money-delivery-fee/{id}",
    REMOVE_MONEY_DELIVERY_FEE_URL: "{HOST}/money-delivery-fee/{id}",

    GET_DELIVERY_COST_URL: "{HOST}/delivery-person/{personId}/delivery-cost?page={page}&pageSize={pageSize}&currency={currency}&geoId={geoId}",
    FIND_DELIVERY_COST_URL: "{HOST}/delivery-cost/{id}",
    UPDATE_DELIVERY_COST_URL: "{HOST}/delivery-cost/{id}",
    CREATE_DELIVERY_COST_URL: "{HOST}/delivery-person/{personId}/delivery-cost",
    REMOVE_DELIVERY_COST_URL: "{HOST}/delivery-person/{personId}/delivery-cost/{id}",

    GET_TRANSACTION_URL: "{HOST}/transaction/{id}?page={page}&pageSize={pageSize}&from={from}&to={to}&status={status}&currency={currency}&transactionType={transactionType}",
    DOWNLOAD_TRANSACTION_CSV_URL: "{HOST}/transaction/{id}/csv?from={from}&to={to}&currency={currency}&transactionType={transactionType}",
    GET_ARTICLE_TRANSACTION_URL: "{HOST}/article-transaction?page={page}&pageSize={pageSize}&entityId={entityId}&from={from}&to={to}&status={status}&articleId={articleId}&transactionType={transactionType}",
    GET_ARTICLE_TRANSACTION_CSV_URL: "{HOST}/article-transaction/{id}/csv?from={from}&to={to}&articleId={articleId}&transactionType={transactionType}",
    GET_ARTICLE_STOCK_CSV_URL: "{HOST}/article-stock/{id}/csv?articleId={articleId}",

    GET_MONEY_REMITTANCE_URL: "{HOST}/product-order/money-delivery?page={page}&pageSize={pageSize}&from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&status={status}&currency={currency}&type={type}&payed={payed}&geoIds={geoIds}&agencyId={agencyId}",
    GET_POSSIBLY_REPEATED_MONEY_REMITTANCE_URL: "{HOST}/product-order/money-delivery/possibly-repeated?clientId={clientId}&contactId={contactId}&currency={currency}&amountToReceive={amountToReceive}&contactBankCardId={contactBankCardId}",
    FIND_MONEY_REMITTANCE_URL: "{HOST}/product-order/money-delivery/{id}",
    CREATE_MONEY_REMITTANCE_URL: "{HOST}/product-order/money-delivery",
    GET_MONEY_DELIVERY_BUDGET: "{HOST}/product-order/money-delivery/budget?currency={currency}&totalToSend={totalToSend}&totalToReceive={totalToReceive}&totalToPay={totalToPay}&agencyId={agencyId}",
    REMOVE_MONEY_DELIVERY_ORDER_URL: "{HOST}/product-order/money-delivery/{id}",
    SET_MONEY_REMITTANCE_DELIVERY_PERSON_URL: "{HOST}/product-order/money-delivery/delivery-person/{deliveryPersonId}",
    UPDATE_MONEY_REMITTANCE_CONTACT_URL: "{HOST}/product-order/money-delivery/{moneyRemitanteId}/contact/{contactId}",
    UNSET_MONEY_REMITTANCE_DELIVERY_PERSON_URL: "{HOST}/product-order/money-delivery/{moneyRemitanteId}",
    UPDATE_MONEY_DELIVERY_ORDER_STATUS_URL: "{HOST}/product-order/money-delivery/{moneyDeliveryId}/status/{status}",
    UPDATE_MONEY_DELIVERY_ORDERS_STATUS_URL: "{HOST}/product-order/money-delivery/status/{status}",
    UPDATE_MONEY_DELIVERY_ORDER_VALUES_URL: "{HOST}/product-order/money-delivery/{moneyDeliveryId}/values",

    GET_PRODUCT_ORDERS_TO_DELIVER: "{HOST}/product-order/{service}/to-deliver?{ids}",

    GET_PACKAGE_DELIVERY_URL: "{HOST}/product-order/package-delivery?page={page}&pageSize={pageSize}&from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&status={status}&deliveryTypes={deliveryTypes}&geoId={geoId}&agencyId={agencyId}&shippingId={shippingId}&shipmentAssigned={shipmentAssigned}&customCategoryIds={customCategoryIds}",
    FIND_PACKAGE_DELIVERY_URL: "{HOST}/product-order/package-delivery/{id}",
    CREATE_PACKAGE_DELIVERY_URL: "{HOST}/product-order/package-delivery",
    GET_PACKAGE_DELIVERY_BUDGET: "{HOST}/product-order/package-delivery/budget?currency={currency}&totalToSend={totalToSend}&totalToReceive={totalToReceive}&totalToPay={totalToPay}&agencyId={agencyId}",
    REMOVE_PACKAGE_DELIVERY_ORDER_URL: "{HOST}/product-order/package-delivery/{id}",
    UPDATE_PACKAGE_DELIVERY_SHIPPING_ID_URL: "{HOST}/product-order/package-delivery/shipping/{shippingId}",
    GET_PACKAGE_DELIVERY_SHIPPING_ID_URL: "{HOST}/product-order/package-delivery/shipping-number",
    SET_PACKAGE_DELIVERY_DELIVERY_PERSON_URL: "{HOST}/product-order/package-delivery/delivery-person/{deliveryPersonId}",
    UPDATE_PACKAGE_DELIVERY_CONTACT_URL: "{HOST}/product-order/package-delivery/{packageDeliveryId}/contact/{contactId}",
    UNSET_PACKAGE_DELIVERY_DELIVERY_PERSON_URL: "{HOST}/product-order/package-delivery/{packageDeliveryId}",
    UPDATE_PACKAGE_DELIVERY_ORDER_STATUS_URL: "{HOST}/product-order/package-delivery/{packageDeliveryId}/status/{status}",
    UPDATE_PACKAGE_DELIVERY_ORDERS_STATUS_URL: "{HOST}/product-order/package-delivery/status/{status}",
    GET_PRODUCT_ORDER_DELIVERY_PERSONS_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info", //PUT
    ADD_PACKAGE_DELIVERY_DELIVERY_PERSON_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info", //POST
    REMOVE_PACKAGE_DELIVERY_DELIVERY_PERSON_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info/{deliveryPersonId}",//POST
    SET_COMMISSION_PACKAGE_DELIVERY_DELIVERY_PERSON_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info/{deliveryPersonId}", //PUT
    CONFIRM_RECEIVED_PACKAGE_DELIVERY_DELIVERY_PERSON_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info/{deliveryPersonId}/received",//POST
    CONFIRM_DELIVERED_PACKAGE_DELIVERY_DELIVERY_PERSON_INFO: "{HOST}/product-order/package-deliveries/delivery-persons-info/{deliveryPersonId}/delivered",
    UPDATE_ITEMS_AND_PAYMENTS_PACKAGE_DELIVERY_URL:"{HOST}/product-order/package-delivery/{packageDeliveryId}/items-and-payments",//POST
    SEND_PACKAGE_DELIVERY_TO_DELIVERY_AGENCY_URL: "{HOST}/product-order/package-delivery/{orderId}/send-to-delivery-agency/{typeCorrespond}",

    GET_INVOICE_URL: "{HOST}/invoice?page={page}&pageSize={pageSize}&from={from}&to={to}&status={status}&filter={filter}&clientId={clientId}",
    FIND_INVOICE_BY_PRODUCT_ORDER_URL: "{HOST}/product-order/{productOrderId}/invoice",
    VIEW_RECEIPT_URL: "{HOST}/product-order/{productOrderId}/receipt?single={single}",
    VIEW_BATCH_RECEIPT_URL: "{HOST}/product-order/receipt?ids={ids}",

    GET_PAYMENT_FEE_URL: "{HOST}/payment/fee?agencyId={agencyId}",
    GET_PAYMENT_FEE_BY_SERVICE_NAME_URL: "{HOST}/payment/fee?serviceName={serviceName}&agencyId={agencyId}",
    UPDATE_PAYMENT_FEE_URL: "{HOST}/payment/fee?agencyId={agencyId}",

    GET_CONTACT_BANK_CARD_URL: "{HOST}/contact/{contactId}/bank-card?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_CONTACT_BANK_CARD_URL: "{HOST}/contact/{contactId}/bank-card/{bankCardId}",
    CREATE_CONTACT_BANK_CARD_URL: "{HOST}/contact/{contactId}/bank-card",
    UPDATE_CONTACT_BANK_CARD_URL: "{HOST}/contact/{contactId}/bank-card/{id}",
    SEARCH_CONTACT_BANK_CARD_URL: "{HOST}/contact/bank-card/search?filter={filter}",
    REMOVE_CONTACT_BANK_CARD_URL: "{HOST}/contact/{contactId}/bank-card/{id}",

    GET_PACKAGE_CATEGORY_COST_URL: "{HOST}/package-category/{id}/cost?page={page}&pageSize={pageSize}&geoId={geoId}",
    FIND_PACKAGE_CATEGORY_COST_URL: "{HOST}/package-category-cost/{id}",
    CREATE_PACKAGE_CATEGORY_COST_URL: "{HOST}/package-category-cost",
    UPDATE_PACKAGE_CATEGORY_COST_URL: "{HOST}/package-category-cost/{id}",
    REMOVE_PACKAGE_CATEGORY_COST_URL: "{HOST}/package-category-cost/{id}",

    GET_PACKAGE_CATEGORY_URL: "{HOST}/package-category?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_PACKAGE_CATEGORY_URL: "{HOST}/package-category/{id}",
    CREATE_PACKAGE_CATEGORY_URL: "{HOST}/package-category",
    GET_SALES_BY_PAYMENT_TYPE_URL: "{HOST}/sales/by-payment-type?from={from}&to={to}&agencyId={agencyId}&userId={userId}",
    GET_SALES_BY_SERVICE_URL: "{HOST}/sales/by-service?from={from}&to={to}&agencyId={agencyId}&userId={userId}&includeChildren={includeChildren}",
    GET_SALES_BY_USER_URL: "{HOST}/sales/by-user?from={from}&to={to}&agencyId={agencyId}",
    GET_SALES_BY_AGENCY_URL: "{HOST}/sales/by-agency?from={from}&to={to}&agencyId={agencyId}",
    GET_MONEY_DELIVERY_SALES_URL: "{HOST}/sales/money-delivery?from={from}&to={to}&agencyId={agencyId}&userId={userId}",
    GET_TOPUP_SALES_URL: "{HOST}/sales/topup?from={from}&to={to}&agencyId={agencyId}&userId={userId}",
    GET_ARTICLE_SALES_URL: "{HOST}/sales/article?from={from}&to={to}&agencyId={agencyId}&userId={userId}",
    GET_MISCELLANY_SALES_URL: "{HOST}/sales/miscellany?from={from}&to={to}&agencyId={agencyId}&userId={userId}",
    GET_MONEY_DELIVERY_ORDER_OVERVIEW_URL: "{HOST}/product-order/money-delivery-overview?from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&status={status}&currency={currency}&type={type}&payed={payed}&geoIds={geoIds}&agencyId={agencyId}&includeChildren={includeChildren}",
    GET_PACKAGE_DELIVERY_ORDER_OVERVIEW_URL: "{HOST}/product-order/package-delivery-overview?from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&status={status}&deliveryTypes={deliveryTypes}&geoId={geoId}&agencyId={agencyId}&shippingId={shippingId}&includeChildren={includeChildren}&customCategoryIds={customCategoryIds}",
    DOWNLOAD_MONEY_DELIVERY_ORDER_CSV_URL: "{HOST}/product-order/money-delivery/csv?from={from}&to={to}&filter={filter}&deliveryPersonId={deliveryPersonId}&status={status}&currency={currency}&type={type}&geoIds={geoIds}&agencyId={agencyId}",
    DOWNLOAD_TOPUP_ORDER_CSV_URL: "{HOST}/product-order/topup-order/csv?from={from}&to={to}&filter={filter}&status={status}&agencyId={agencyId}",

    GET_SALE_PRICE_URL: "{HOST}/sale-price?page={page}&pageSize={pageSize}&filter={filter}",
    GET_SALE_PRICE_FROM_AGENCY_URL: "{HOST}/sale-price/from-agency",
    FIND_SALE_PRICE_URL: "{HOST}/sale-price/{id}",
    CREATE_SALE_PRICE_URL: "{HOST}/sale-price",
    CLONE_SALE_PRICE_URL: "{HOST}/sale-price/{id}/clone",
    UPDATE_SALE_PRICE_URL: "{HOST}/sale-price/{id}",
    SET_SALE_PRICE_ACTIVE_URL: "{HOST}/sale-price/{id}/setActive",
    SET_SALE_PRICE_INACTIVE_URL: "{HOST}/sale-price/{id}/setInactive",
    REMOVE_SALE_PRICE_URL: "{HOST}/sale-price/{id}",
    COPY_SALE_PRICE_ITEMS_URL: "{HOST}/sale-price/{id}/copy-values",

    // Products sale prices
    CREATE_ARTICLE_SALE_PRICE_URL: "{HOST}/sale-price/{id}/article/{articleId}",
    UPDATE_ARTICLE_SALE_PRICE_URL: "{HOST}/sale-price/{id}/article/{articleId}/price/{articleSalePriceId}",
    REMOVE_ARTICLE_SALE_PRICE_URL: "{HOST}/sale-price/{id}/article-sale-price/{articleSalePriceId}",
    UPDATE_MONEY_SALE_PRICE_URL: "{HOST}/sale-price/{id}/money/{moneySalePriceId}/value",
    UPDATE_MONEY_SALE_PRICE_CURRENCIES_URL: "{HOST}/sale-price/{id}/money/{moneySalePriceId}/values",
    REMOVE_MONEY_SALE_PRICE_URL: "{HOST}/sale-price/{id}/money/{moneySalePriceId}",
    CREATE_MONEY_SALE_PRICE_CURRENCIES_URL: "{HOST}/sale-price/{id}/money",
    UPDATE_TOPUP_SALE_PRICE_URL: "{HOST}/sale-price/{id}/topup/{productId}",
    UPDATE_REFERENCE_ITEM_SALE_PRICE_URL:"{HOST}/sale-price/{id}/package-reference-item/{referenceItemId}",
    // Package Custom Category Weight Range Sale Prices
    ADD_CUSTOM_CATEGORY_WEIGHT_RANGE_SALE_PRICE_URL:"{HOST}/sale-price/{id}/package/custom-category/{customCategoryId}/weight-range",
    UPDATE_CUSTOM_CATEGORY_WEIGHT_RANGE_SALE_PRICE_URL:"{HOST}/sale-price/{id}/package/custom-category/weight-range/{salePriceCustomCategoryWeightRangeId}",
    REMOVE_CUSTOM_CATEGORY_WEIGHT_RANGE_SALE_PRICE_URL:"{HOST}/sale-price/{id}/package/custom-category/weight-range/{salePriceCustomCategoryWeightRangeId}",
    // Miscellany Category Sale Prices
    ADD_MISCELLANY_SALE_PRICE_URL: "{HOST}/sale-price/{id}/miscellany-category/{miscellanyCategoryId}",
    UPDATE_MISCELLANY_SALE_PRICE_URL: "{HOST}/sale-price/{id}/miscellany-category/{miscellanyCategoryId}",
    GET_CUSTOM_CATEGORY_WEIGHT_RANGES_FROM_BASE_AGENCY_URL: "{HOST}/weight-range/from-base-agency",

    // Custom Category
    GET_CUSTOM_CATEGORY_URL:"{HOST}/custom-category?page={page}&pageSize={pageSize}&filter={filter}",
    CREATE_CUSTOM_CATEGORY_URL:"{HOST}/custom-category",
    FIND_CUSTOM_CATEGORY_URL:"{HOST}/custom-category/{id}",
    UPDATE_CUSTOM_CATEGORY_URL:"{HOST}/custom-category/{id}",
    REMOVE_CUSTOM_CATEGORY_URL:"{HOST}/custom-category/{id}",

    // Custom Category Weight Ranges
    GET_WEIGHT_RANGES_URL:"{HOST}/weight-range?agencyId={agencyId}",
    GET_CUSTOM_CATEGORY_WEIGHT_RANGE_URL:"{HOST}/custom-category/{customCategoryId}/weight-range",
    FIND_CUSTOM_CATEGORY_WEIGHT_RANGE_URL:"{HOST}/custom-category/{customCategoryId}/weight-range/{weightRangeId}",
    CREATE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL:"{HOST}/custom-category/{customCategoryId}/weight-range",
    UPDATE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL:"{HOST}/custom-category/{customCategoryId}/weight-range/{weightRangeId}",
    REMOVE_CUSTOM_CATEGORY_WEIGHT_RANGE_URL:"{HOST}/custom-category/{customCategoryId}/weight-range/{weightRangeId}",

    // GET_PRICE_FROM_CUSTOM_CATEGORY_URL
    GET_PRICE_FROM_CUSTOM_CATEGORY_URL:"{HOST}/custom-category/{customCategoryId}/weight-range/by-weight?weight={weight}&deliveryType={deliveryType}&agencyId={agencyId}",

    // Inventory Item
    GET_INVENTORY_ITEM_URL:"{HOST}/inventory-item?page={page}&pageSize={pageSize}&filter={filter}&customCategoryId={customCategoryId}",
    CREATE_INVENTORY_ITEM_URL:"{HOST}/inventory-item",
    FIND_INVENTORY_ITEM_URL:"{HOST}/inventory-item/{id}",
    UPDATE_INVENTORY_ITEM_URL:"{HOST}/inventory-item/{id}",
    REMOVE_INVENTORY_ITEM_URL:"{HOST}/inventory-item/{id}",

    // Reference Item
    GET_REFERENCE_ITEM_URL:"{HOST}/reference-item?page={page}&pageSize={pageSize}&filter={filter}",
    CREATE_REFERENCE_ITEM_URL:"{HOST}/reference-item",
    FIND_REFERENCE_ITEM_URL:"{HOST}/reference-item/{id}",
    UPDATE_REFERENCE_ITEM_URL:"{HOST}/reference-item/{id}",
    REMOVE_REFERENCE_ITEM_URL:"{HOST}/reference-item/{id}",

    //Reference Item Price
    GET_REFERENCE_ITEM_PRICE_URL:"{HOST}/reference-item-price?page={page}&pageSize={pageSize}&filter={filter}",
    CREATE_REFERENCE_ITEM_PRICE_URL:"{HOST}/reference-item-price",
    FIND_REFERENCE_ITEM_PRICE_URL:"{HOST}/reference-item-price/{id}",
    UPDATE_REFERENCE_ITEM_PRICE_URL:"{HOST}/reference-item-price/{referenceItemId}/amount/{amount}",
    REMOVE_REFERENCE_ITEM_PRICE_URL:"{HOST}/reference-item-price/{id}",
    GET_REFERENCE_ITEM_PRICE_FROM_BASE_AGENCY_URL: "{HOST}/reference-item-price/from-base-agency",

    // NOTIFICATIONS
    GET_USER_NOTIFICATIONS_URL: "{HOST}/notification",
    UPDATE_USER_NOTIFICATIONS_STATUS_URL: "{HOST}/notification",
    REMOVE_NOTIFICATION_URL: "{HOST}/notification/{id}",

    // PROMOTIONS
    GET_PROMOTIONS_URL: "{HOST}/promotion?page={page}&pageSize={pageSize}&filter={filter}",
    GET_ACTIVE_PROMOTIONS_URL: "{HOST}/promotion/active",
    FIND_PROMOTION_URL: "{HOST}/promotion/{id}",
    CREATE_PROMOTION_URL: "{HOST}/promotion",
    UPDATE_PROMOTION_URL: "{HOST}/promotion/{id}",
    REMOVE_PROMOTION_URL: "{HOST}/promotion/{id}",
    UPLOAD_PROMOTION_IMAGE_URL: "{HOST}/promotion/{id}/upload-image",

    // BILLING PERIODS
    GET_BILLING_PERIODS_URL: "{HOST}/billing-period?page={page}&pageSize={pageSize}&filter={filter}",
    GET_CHILD_AGENCY_BILLING_PERIODS_URL: "{HOST}/child-agency-billing-period?page={page}&pageSize={pageSize}&filter={filter}",
    FIND_BILLING_PERIOD_URL: "{HOST}/billing-period/{id}",
    CREATE_BILLING_PERIOD_URL: "{HOST}/billing-period",
    UPDATE_BILLING_PERIOD_URL: "{HOST}/billing-period/{id}",
    REMOVE_BILLING_PERIOD_URL: "{HOST}/billing-period/{id}",
    CLOSE_BILLING_PERIOD_URL: "{HOST}/billing-period/{id}/close",
    BILL_BILLING_PERIOD_URL: "{HOST}/billing-period/{id}/bill",

    // AGENCY BILLING CLOSURE
    GET_AGENCY_BILLING_CLOSURE_URL: "{HOST}/billing-period/{id}/agency-closure",
    UPDATE_AGENCY_BILLING_CLOSURE_URL: "{HOST}/agency-closure/{id}",

    // MISCELLANY_CATEGORY
    GET_MISCELLANY_CATEGORY_URL: "{HOST}/miscellany-category?page={page}&pageSize={pageSize}&filter={filter}&agencyId={agencyId}",
    FIND_MISCELLANY_CATEGORY_URL: "{HOST}/miscellany-category/{id}",
    CREATE_MISCELLANY_CATEGORY_URL: "{HOST}/miscellany-category",
    UPDATE_MISCELLANY_CATEGORY_URL: "{HOST}/miscellany-category/{id}",
    REMOVE_MISCELLANY_CATEGORY_URL: "{HOST}/miscellany-category/{id}",
    UPDATE_MISCELLANY_CATEGORY_PRICE_URL: "{HOST}/product-order/miscellany-category/{id}/price",

    // MISCELLANY ORDER
    GET_MISCELLANY_ORDER_URL: "{HOST}/product-order/miscellany?page={page}&pageSize={pageSize}&from={from}&to={to}&filter={filter}&status={status}&agencyId={agencyId}",
    CREATE_MISCELLANY_ORDER_URL: "{HOST}/product-order/miscellany",
    UPDATE_MISCELLANY_ORDER_STATUS_URL: "{HOST}/product-order/miscellany/{id}/status/{status}",
    UPDATE_MISCELLANY_ORDERS_STATUS_URL: "{HOST}/product-order/miscellany/status/{status}",
    REMOVE_MISCELLANY_ORDER_URL: "{HOST}/product-order/miscellany/{id}",
    UPDATE_MISCELLANY_ORDER_DESCRIPTION_URL: "{HOST}/product-order/miscellany/{id}/description",

    // SHOP PRODUCT
    GET_SHOP_PRODUCT_URL: "{HOST}/shop-product?page={page}&pageSize={pageSize}&filter={filter}",
    GET_ALL_SHOP_PRODUCT_URL: "{HOST}/all-shop-products",
    FIND_SHOP_PRODUCT_URL: "{HOST}/shop-product/{id}",
    CREATE_SHOP_PRODUCT_URL: "{HOST}/shop-product",
    UPDATE_SHOP_PRODUCT_URL: "{HOST}/shop-product/{id}",
    REMOVE_SHOP_PRODUCT_URL: "{HOST}/shop-product/{id}",
    UPLOAD_SHOP_PRODUCT_IMAGE_URL: "{HOST}/shop-product/{id}/upload-image",
    GET_SHOP_PRODUCT_STOCK_TRANSACTION_URL: "{HOST}/shop-product/{id}/stock-transaction?page={page}&pageSize={pageSize}&from={from}&to={to}",

    // SHOP ORDER
    GET_SHOP_ORDER_URL: "{HOST}/product-order/shop?page={page}&pageSize={pageSize}&from={from}&to={to}&filter={filter}&status={status}&agencyId={agencyId}",
    CREATE_SHOP_ORDER_URL: "{HOST}/product-order/shop",
    REMOVE_SHOP_ORDER_URL: "{HOST}/product-order/shop/{id}",

    // TRACE
    GET_PRODUCT_ORDER_TRACE_URL: "{HOST}/trace/product-order/{id}",

    // MESSAGING
    SEND_CLIENT_SMS_URL: "{HOST}/client/sms",
    SEND_AGENCY_CLIENT_SMS_URL: "{HOST}/agency/client/sms",

    // AGENCY BALANCE TRANSACTIONS
    GET_AGENCY_BALANCE_TRANSACTION_URL: "{HOST}/agency/{id}/balance-transaction?page={page}&pageSize={pageSize}&from={from}&to={to}&status={status}",
    ADD_BALANCE_TO_AGENCY_URL: "{HOST}/agency/{id}/balance",
};


export default values;
